import { graphql } from 'react-relay';

export const labeledSelectBoxFragment = graphql`
    fragment LabeledSelectBox_labeledSelectBox on LabeledSelectBox {
        label
        selectbox {
            ...Selectbox_selectBox
        }
    }
`;
